<style lang="scss">
.hamburger-button {
    width: 20px;
    height: 14px;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-between;
    margin: auto 0 auto 0;
    transition: height 0.2s;
    z-index: 200;

    span {
        @apply text-dark bg-dark;
        height: 2px;
        width: 20px;
        border-radius: 1px;
        display: flex;
        transition: all 0.2s;
        transform-origin: left;
        align-self: flex-end;
    }

    &.active {
        height: 14px;
        span {
            width: 17px;

            @apply bg-dark;

            &:nth-child(1) {
                transform: translateX(2px) rotate(45deg);
            }
            &:nth-child(2) {
                opacity: 0;
            }
            &:nth-child(3) {
                transform: translateX(2px) rotate(-45deg);
            }
        }
    }
}

.jobs .hamburger-button {
    span {
        @media (max-width: 1023.98px) {
            @apply bg-white;
        }
    }
}
</style>

<template>
    <div class="hamburger-button xl:hidden flex" :class="{ active: active }" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
import { bus } from "@/app";

export default {
    props: {
        openActive: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data: function() {
        return {
            active: false
        };
    },

    created() {
        if (this.openActive) this.active = true;

        bus.$on("hamburger-close", () => {
            this.active = false;
        });

        bus.$on("hamburger-open", () => {
            this.active = true;
        });
    },

    methods: {
        toggleMenu: function() {
            if (this.active) {
                bus.$emit("hamburger-close");
            } else {
                bus.$emit("hamburger-open");
            }

            this.$root.navigationIsVisble = !this.$root.navigationIsVisble;
        }
    }
};
</script>
